import { InputElement } from "./InputStyles";

function Input(props: any) {
  return <InputElement {...props} />;
}

export default Input;
